import { styled as styling } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Color from "../../../assets/colors";

export const useStyles = makeStyles((theme) => ({
  scrollBar: {
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
      backgroundColor: "transparent",
      width: 4,
      overflow: "auto",
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
      borderRadius: 64,
      backgroundColor: Color.hiredlyPurple,
      overflow: "auto",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: 64,
      backgroundColor: Color.grey,
    },
  },
}));

export const DescriptionWrapper = styling("div")((props) => ({
  display: "flex",

  gap: "2rem",

  flexDirection: props.$companySocial > 2 ? "column" : "row",
  maxHeight: props.$companySocial > 0 ? "10rem" : "25rem",

  overflowX: "clip",
  overflowY: props.$companySocial > 2 ? "scroll" : "visible",

  "@media (max-width:1279px)": {
    maxHeight: props.$companySocial > 0 ? "11.5rem" : "25rem",
    flexDirection: props.$companySocial > 0 ? "column" : "row",
    gap: "1.5rem",

    maxHeight: props.$companySocial > 0 ? "8.25rem" : "15rem",
    overflowY: props.$companySocial > 0 ? "scroll" : "visible",
  },

  "@media (max-width:640px)": {
    maxHeight: props.$companySocial > 0 ? "11.5rem" : "25rem",
    flexDirection: "column",
    gap: "0",

    maxHeight: "37.5rem",
    overflowY: "visible",
  },
}));

export const DescriptionContainer = styling("div")((props) => ({
  display: "flex",
  flexDirection: "column",

  overflowX: "clip",
  overflowY: props.$companySocial > 2 ? "visible" : "auto",
  maxHeight:
    props.$companySocial > 0
      ? props.$companySocial > 2
        ? "fit-content"
        : "10.5rem"
      : "25rem",
  height: "100%",
  width: props.$companySocial > 2 ? "100%" : "50%",
  padding: "0 2rem 0 0",

  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "transparent",
    width: 4,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 64,
    backgroundColor: Color.hiredlyPurple,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: 64,
    backgroundColor: Color.grey,
  },

  "@media (max-width:1279px)": {
    overflowY: props.$companySocial > 0 ? "visible" : "auto",
    maxHeight: props.$companySocial > 0 ? "fit-content" : "15rem",
    width: props.$companySocial > 0 ? "100%" : "50%",
  },

  "@media (max-width:640px)": {
    maxHeight: "16.5rem",
    overflowY: "auto",
    width: "100%",
  },
}));

export const DescriptionBody = styling("div")({
  letterSpacing: "0.15px",

  "& p": {
    margin: "0 0 16px 0",
  },

  "& ul": {
    padding: "0 0 0 20px",
    margin: "0 0 16px 0",
  },
});
